import { jsx as r } from "@emotion/react/jsx-runtime";
import { useSidebarContext as n } from "../../SidebarContext.js";
import { BaseMenuItem as m } from "../BaseMenu/BaseMenu.js";
import { StyledElement as o } from "../BaseMenu/BaseMenu.styled.js";
const a = ({
  route: e
}) => {
  const {
    extended: t
  } = n();
  return /* @__PURE__ */ r(m, { route: e, children: /* @__PURE__ */ r(o, { extended: t, children: e.name }) });
};
export {
  a as MenuPartnerLink
};
